import React, { useCallback, useState } from "react";
// lib
import { Autocomplete } from "../../../../components/lib/Autocomplete";
import Box from "../../../../components/lib/Box";
// hooks
import { useRateSearchFormStore } from "../../../../stores/RateSearchForm";
import { useFetchJobLibrary } from "./hooks";
import { JobLibrary } from "../../types";

type Props = {
  onResetJobOptions(): void;
};

export function JobLibraryField(props: Props) {
  const { onResetJobOptions } = props;
  const setLibrary = useRateSearchFormStore((s) => s.setLibrary);
  const jobLibrary = useRateSearchFormStore((s) => s.jobLibrary);
  const [value, setValue] = useState(jobLibrary?.name ?? "");
  const { loading, options } = useFetchJobLibrary();

  const onResetOptions = useCallback(() => {
    setLibrary(null, null);
    onResetJobOptions();
    setValue("");
  }, [setLibrary, onResetJobOptions, setValue]);

  const onSelect = useCallback(
    (lib: JobLibrary | null) => {
      setLibrary(lib, null);
      onResetJobOptions();
      if (lib) setValue(lib.name);
    },
    [setLibrary, onResetJobOptions, setValue]
  );

  return (
    <Box css={{ width: "100%" }}>
      <Autocomplete
        icon="book"
        loading={loading}
        id="job-library-select"
        selected={jobLibrary}
        options={options}
        onResetOptions={onResetOptions}
        onSelect={onSelect}
        label="Select a job library"
        placeholder="Select a library"
        readOnly
        getKey={(o) => String(o.databaseId)}
        renderOption={(o) => o.name}
        inputValue={value}
        onInputChange={(e) => setValue(e.target.value)}
      />
    </Box>
  );
}
